import { CookieSettingsOutlineIcon } from './CookieSettingsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id FF72A11B-A9E5-47B7-967F-C520DC965CE2
 * name cookie-settings-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-settings-outline.svg
 * tags
 * - Food / Drink 
 * - Settings 
 */
export const BiscuitSettingsOutlineIcon = CookieSettingsOutlineIcon;
export default BiscuitSettingsOutlineIcon